// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AuRXwF9VsP8fQq1a {
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
}

.AuRXwF9VsP8fQq1a > h3 {
  margin-block-end: 0;
}

.B5s355_gSI7ItcD6 {
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  gap: 1.625rem;
}

.iqtx7ymJ3Roy3C5j {
  display: flex;
  flex-direction: row;
}

.QXRnIuUGzcm0uOKl {
  margin-left: 0.5rem;
  margin-top: -0.35rem;
  font-weight: 400;
  font-size: 14px;
}

.RuamqV3Xxkom2CqJ {
  margin-left: 0.5rem;
  margin-top: 0.15rem;
  font-weight: 700;
  font-size: 20px;
}

.Pyqd8S5JSC0zR2L_ {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
}

.MIMjymJE5pk3gs1I {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;
  height: 100%;
	margin-top: -0.5rem;
}

.oLWzot0tC7gavhWw {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 5.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background-color: #fffadb;
}

.oLWzot0tC7gavhWw > span {
  font-weight: 400;
  font-size: 0.875rem;
  margin-top: 1.6rem;
  margin-bottom: -26px;
}

.oLWzot0tC7gavhWw > p {
  font-weight: 700;
  font-size: 1.875rem;
}

.HrZfZT3iYo2GrjpC {
	width: 23.813rem;
	height: auto;
	min-height: 28.875rem;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
	border-radius: 1rem;
}

.RBKMBOXtnh4Q1ohj {
  width: 609px;
  height: 462px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.12);
  border-radius: 1rem;
}

.Oh5Ir_c3QJo6As9g {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.537rem;
}

.VHDQ_rFZJ8sxjttS {
  width: 100%;
  overflow-x: scroll;
}

.WbTw6OnjALtl5ak2 {
  height: 17.375rem;
}

.ihcr_xpUf_MfYgMz {
  height: 17.375rem;
  margin-top: -0.25rem;
}

.GWpnlugYRBAcZyTS {
	display: flex;
	margin-top: 2rem;
	gap: 5rem;
}

.GWpnlugYRBAcZyTS > div {
  display: flex;
  flex-direction: row;
}

.GWpnlugYRBAcZyTS > div p {
  margin-top: -0.15rem;
  margin-left: 0.7rem;
}

.GWpnlugYRBAcZyTS > div:nth-child(1) span {
  background-color: #c43908;
}

.GWpnlugYRBAcZyTS > div:nth-child(2) span {
  background-color: #ff8f3f;
}

.GWpnlugYRBAcZyTS > div:nth-child(3) span {
  background-color: #ffc44e;
}

.GWpnlugYRBAcZyTS span {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 25%;
}

.dsVUQqiQMWNFDSOh {
  height: 100%;
}

.RpTxQH_UViY4ugEx {
	width: 16.813rem;
	height: 28.875rem;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
	border-radius: 1rem;
}

.dHKRy4_wQ9oMrEvZ {
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
}

.jxJmKG5RNJQv3ZB_ {
	display: flex;
	flex-direction: column;
	width: 50%;
	padding: 1.375rem 5em 0;
	background-color: #FFF;
	height: 111px;
}

.jxJmKG5RNJQv3ZB_ span {
	font-weight: 400;
	font-size: 0.875rem;
	color: #767676;
	margin-top: 0;
}

.jxJmKG5RNJQv3ZB_ p {
	font-weight: 900;
	font-size: 1.875rem;
	color: #303030;
	margin-top: 0.7rem;
	margin-bottom: 0;
}

.iwcii3Z3vf4IhBvO {
	display: flex;
	flex-direction: column;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
	border-radius: 1rem;
	margin-top: 1rem;
	width: 100%;
	padding: 0 5em 0;
}

.iwcii3Z3vf4IhBvO .p-card-title {
	color: #303030;
	font-size: 20px;
	font-weight: 700;
	margin-top: 45px;
}

.p-datatable-table {
	border-radius: 16px;
	overflow: hidden;
}

.p-datatable-thead th:first-child > div {
	display: flex;
	justify-content: flex-start;
}

.p-datatable-thead th > div {
	display: flex;
	justify-content: center;
	color: #303030;
	font-size: 1rem;
	font-weight: 600;
}

.p-datatable-thead th {
	background-color: #C6D4E1;
	border: 1px solid #FFF;
	padding: 18px 30px;
}

.p-datatable-tbody tr td {
	text-align: center;
	background-color: #FAF9F8;
	border: 1px solid #FFF;
	font-size: 1rem;
	font-weight: 400;
}

/*.cellName {*/
/*	width: 15.625rem;*/
/*	display: flex;*/
/*	justify-content: flex-start;*/
/*	margin-left: 0.8rem;*/
/*}*/

.X9vFL3V15Is0vhYh {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.zQWnWoZsAsUTxM9P {
	width: 250px;
	height: 250px;
	margin-top: 28px;
}

.SiMoS7Z0Ub4o3kkk {
	margin-top: 38px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 1.5rem;
	max-width: 100%;
}

.wy10DOQB8x4nfmQn {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.ySXLOv_OJsbwRXOb {
	display: flex;
	gap: 1rem;
	flex-direction: row;
}

.q16ZVCV3sT0xAeLb .p-datatable-tbody td:nth-child(1),
.q16ZVCV3sT0xAeLb .p-datatable-thead th:nth-child(1) {
	width: 30%;
	text-align: left;
}

.q16ZVCV3sT0xAeLb .p-datatable-tbody td:nth-child(2),
.q16ZVCV3sT0xAeLb .p-datatable-thead th:nth-child(2) {
	width: 20%;
}

.q16ZVCV3sT0xAeLb .p-datatable-tbody td:nth-child(3),
.q16ZVCV3sT0xAeLb .p-datatable-thead th:nth-child(3) {
	width: 10%;
}

.q16ZVCV3sT0xAeLb .p-datatable-tbody td:nth-child(4),
.q16ZVCV3sT0xAeLb .p-datatable-thead th:nth-child(4) {
	width: 15%;
}

.q16ZVCV3sT0xAeLb .p-datatable-tbody td:nth-child(5),
.q16ZVCV3sT0xAeLb .p-datatable-thead th:nth-child(5) {
	width: 20%;
}

@media screen and (min-width: 1105px) and (max-width: 1665px) {
	.B5s355_gSI7ItcD6 {
		flex-wrap: wrap;
		justify-content: center;
	}
	
	/* .chartsBlock {
		overflow-x: hidden;
	} */
	
	.RBKMBOXtnh4Q1ohj,
	.HrZfZT3iYo2GrjpC,
	.RpTxQH_UViY4ugEx {
		flex: 1 1 300px;
		max-width: 100%;
	}
	
	.GWpnlugYRBAcZyTS {
		flex-wrap: wrap;
		justify-content: center;
		gap: 1rem;
	}
	
	.iwcii3Z3vf4IhBvO {
		padding: 0 2rem;
	}
}

@media screen and (max-width: 1104px) {
	.B5s355_gSI7ItcD6 {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	
	.HrZfZT3iYo2GrjpC {
		width: 24rem;
		height: auto;
	}
	
	.HrZfZT3iYo2GrjpC .p-card-title {
		color: #303030;
		font-size: 16px;
		font-weight: 700;
	}
	
	.RBKMBOXtnh4Q1ohj {
		width: 24rem;
		height: 400px;
	}
	
	.RBKMBOXtnh4Q1ohj .p-card-title {
		color: #303030;
		font-size: 16px;
		font-weight: 700;
	}
	
	.GWpnlugYRBAcZyTS {
		display: flex;
		margin-top: 26px;
		gap: 1rem;
	}
	
	.GWpnlugYRBAcZyTS > div p {
		font-size: 12px;
		font-weight: 400;
	}
	
	.GWpnlugYRBAcZyTS span {
		display: inline-block;
		width: 14px;
		height: 14px;
		border-radius: 4px;
	}
	
	.RpTxQH_UViY4ugEx {
		width: 24rem;
		height: 451px;
	}
	
	.RpTxQH_UViY4ugEx .p-card-title {
		color: #303030;
		font-size: 16px;
		font-weight: 700;
	}
	
	.iwcii3Z3vf4IhBvO {
		padding: 0;
		align-self: center;
	}
	
	.iwcii3Z3vf4IhBvO .p-card-title {
		color: #303030;
		font-size: 14px;
		font-weight: 700;
		margin-top: 0;
	}
	
	.iwcii3Z3vf4IhBvO .p-card-content {
		padding-top: 0;
	}
	
	.iwcii3Z3vf4IhBvO .p-card-content h4{
		font-size: 12px;
		font-weight: 300;
		margin-bottom: 8px !important;
	}
	
	.dHKRy4_wQ9oMrEvZ {
		margin-top: 36px;
	}
	
	.wy10DOQB8x4nfmQn {
		flex-direction: column;
	}
	
	.ySXLOv_OJsbwRXOb {
		flex-direction: column;
	}
	
	.jxJmKG5RNJQv3ZB_ {
		width: 100%;
		padding: 0;
		height: 88px;
		align-items: center;
	}
	
	.jxJmKG5RNJQv3ZB_ span {
		margin-top: 18px;
		font-size: 12px;
		font-weight: 400;
		color: #767676;
	}
	
	.jxJmKG5RNJQv3ZB_ p {
		font-weight: 900;
		font-size: 30px;
		margin-top: 10px;
	}
	
	.q16ZVCV3sT0xAeLb table thead tr th {
		max-height: 31px !important;
	}
	
	.q16ZVCV3sT0xAeLb .p-datatable-thead th {
		padding: 10px 0;
	}
	
	.q16ZVCV3sT0xAeLb .p-datatable-thead th:first-child > div {
		margin-left: 30px;
	}
}

@media screen and (max-width: 768px) {
	.q16ZVCV3sT0xAeLb table thead tr th > div > span {
		font-size: 10px;
		font-weight: 700;
	}
	
	.q16ZVCV3sT0xAeLb table tbody tr td > div {
		font-size: 10px;
		font-weight: 400;
	}
	
	.q16ZVCV3sT0xAeLb table tbody tr td {
		font-size: 10px;
		font-weight: 400;
	}
}

@media screen and (max-width: 425px) {
	.q16ZVCV3sT0xAeLb table thead tr th > div > span {
		font-size: 9px;
		font-weight: 700;
	}
	
	.q16ZVCV3sT0xAeLb table tbody tr td > div {
		font-size: 9px;
		font-weight: 400;
	}
	
	.q16ZVCV3sT0xAeLb table tbody tr td {
		font-size: 9px;
		font-weight: 400;
	}
}

@media screen and (max-width: 423px) and (min-width: 375px) {
	.HrZfZT3iYo2GrjpC {
		width: 20rem;
		height: auto;
	}
	
	.SiMoS7Z0Ub4o3kkk {
		gap: 3rem;
		margin-top: 1rem;
	}
	
	.RBKMBOXtnh4Q1ohj {
		width: 20rem;
		height: 400px;
	}
	
	.RpTxQH_UViY4ugEx {
		width: 20rem;
		height: 451px;
	}
}

@media screen and (max-width: 374px) {
	.HrZfZT3iYo2GrjpC {
		width: 17rem;
		height: auto;
	}
	
	.SiMoS7Z0Ub4o3kkk {
		gap: 1.5rem;
		margin-top: 0.9rem;
	}
	
	.RBKMBOXtnh4Q1ohj {
		width: 17rem;
		height: 400px;
	}
	
	.GWpnlugYRBAcZyTS span {
		max-width: 10px;
		max-height: 10px;
		border-radius: 25%;
	}
	
	.RpTxQH_UViY4ugEx {
		width: 17rem;
		height: 451px;
	}
}

@media screen and (max-width: 370px) {
	.q16ZVCV3sT0xAeLb .p-datatable-thead th,
	.q16ZVCV3sT0xAeLb .p-datatable-tbody td {
		padding: 6px 4px;
		font-size: 8px;
	}
	
	.q16ZVCV3sT0xAeLb .p-datatable-thead th:first-child > div {
		margin-left: 10px;
	}
	
	.q16ZVCV3sT0xAeLb .p-datatable-thead th > div,
	.q16ZVCV3sT0xAeLb .p-datatable-tbody td > div {
		font-size: 8px;
	}
	
	.q16ZVCV3sT0xAeLb .p-datatable-tbody td:nth-child(1),
	.q16ZVCV3sT0xAeLb .p-datatable-thead th:nth-child(1) {
		width: 25%;
	}
	
	.q16ZVCV3sT0xAeLb .p-datatable-tbody td:nth-child(2),
	.q16ZVCV3sT0xAeLb .p-datatable-thead th:nth-child(2) {
		width: 18%;
	}
	
	.q16ZVCV3sT0xAeLb .p-datatable-tbody td:nth-child(3),
	.q16ZVCV3sT0xAeLb .p-datatable-thead th:nth-child(3) {
		width: 10%;
	}
	
	.q16ZVCV3sT0xAeLb .p-datatable-tbody td:nth-child(4),
	.q16ZVCV3sT0xAeLb .p-datatable-thead th:nth-child(4) {
		width: 15%;
	}
	
	.q16ZVCV3sT0xAeLb .p-datatable-tbody td:nth-child(5),
	.q16ZVCV3sT0xAeLb .p-datatable-thead th:nth-child(5) {
		width: 18%;
	}
}`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/Statistic/StationStatistics.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;CACb,mBAAmB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,qBAAqB;CACrB,sGAAsG;CACtG,mBAAmB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;iCAC+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,SAAS;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,sGAAsG;CACtG,mBAAmB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,UAAU;CACV,uBAAuB;CACvB,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;CACd,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;CACd,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,sGAAsG;CACtG,mBAAmB;CACnB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,sBAAsB;CACtB,eAAe;CACf,gBAAgB;AACjB;;AAEA,cAAc;AACd,qBAAqB;AACrB,kBAAkB;AAClB,gCAAgC;AAChC,wBAAwB;AACxB,IAAI;;AAEJ;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,eAAe;CACf,uBAAuB;CACvB,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;AACpB;;AAEA;;CAEC,UAAU;CACV,gBAAgB;AACjB;;AAEA;;CAEC,UAAU;AACX;;AAEA;;CAEC,UAAU;AACX;;AAEA;;CAEC,UAAU;AACX;;AAEA;;CAEC,UAAU;AACX;;AAEA;CACC;EACC,eAAe;EACf,uBAAuB;CACxB;;CAEA;;IAEG;;CAEH;;;EAGC,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,uBAAuB;EACvB,SAAS;CACV;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;CACxB;;CAEA;EACC,YAAY;EACZ,YAAY;CACb;;CAEA;EACC,cAAc;EACd,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,YAAY;EACZ,aAAa;CACd;;CAEA;EACC,cAAc;EACd,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,gBAAgB;EAChB,SAAS;CACV;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;CACnB;;CAEA;EACC,YAAY;EACZ,aAAa;CACd;;CAEA;EACC,cAAc;EACd,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,UAAU;EACV,kBAAkB;CACnB;;CAEA;EACC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;CACd;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;CAC9B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;CACf;;CAEA;EACC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,YAAY;CACb;;CAEA;EACC,SAAS;EACT,gBAAgB;CACjB;;CAEA;EACC,YAAY;EACZ,aAAa;CACd;;CAEA;EACC,YAAY;EACZ,aAAa;CACd;AACD;;AAEA;CACC;EACC,YAAY;EACZ,YAAY;CACb;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,YAAY;EACZ,aAAa;CACd;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;CACnB;;CAEA;EACC,YAAY;EACZ,aAAa;CACd;AACD;;AAEA;CACC;;EAEC,gBAAgB;EAChB,cAAc;CACf;;CAEA;EACC,iBAAiB;CAClB;;CAEA;;EAEC,cAAc;CACf;;CAEA;;EAEC,UAAU;CACX;;CAEA;;EAEC,UAAU;CACX;;CAEA;;EAEC,UAAU;CACX;;CAEA;;EAEC,UAAU;CACX;;CAEA;;EAEC,UAAU;CACX;AACD","sourcesContent":[".chartsBlock {\r\n  margin-top: 3rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.chartsBlock > h3 {\r\n  margin-block-end: 0;\r\n}\r\n\r\n.cardWrapper {\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin-top: 1rem;\r\n  gap: 1.625rem;\r\n}\r\n\r\n.label {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.labelTitle {\r\n  margin-left: 0.5rem;\r\n  margin-top: -0.35rem;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n}\r\n\r\n.labelValue {\r\n  margin-left: 0.5rem;\r\n  margin-top: 0.15rem;\r\n  font-weight: 700;\r\n  font-size: 20px;\r\n}\r\n\r\n.labelDot {\r\n  width: 0.5rem;\r\n  height: 0.5rem;\r\n  border-radius: 50%;\r\n}\r\n\r\n.timeBlocksWrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.7rem;\r\n  height: 100%;\r\n\tmargin-top: -0.5rem;\r\n}\r\n\r\n.timeBlock {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: 5.5rem;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 16px;\r\n  background-color: #fffadb;\r\n}\r\n\r\n.timeBlock > span {\r\n  font-weight: 400;\r\n  font-size: 0.875rem;\r\n  margin-top: 1.6rem;\r\n  margin-bottom: -26px;\r\n}\r\n\r\n.timeBlock > p {\r\n  font-weight: 700;\r\n  font-size: 1.875rem;\r\n}\r\n\r\n.doughnutCard {\r\n\twidth: 23.813rem;\r\n\theight: auto;\r\n\tmin-height: 28.875rem;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n\tborder-radius: 1rem;\r\n}\r\n\r\n.barCard {\r\n  width: 609px;\r\n  height: 462px;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06),\r\n    0 2px 6px rgba(0, 0, 0, 0.12);\r\n  border-radius: 1rem;\r\n}\r\n\r\n.barCardContent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.537rem;\r\n}\r\n\r\n.barChartWrapper {\r\n  width: 100%;\r\n  overflow-x: scroll;\r\n}\r\n\r\n.barChartContent {\r\n  height: 17.375rem;\r\n}\r\n\r\n.barChart {\r\n  height: 17.375rem;\r\n  margin-top: -0.25rem;\r\n}\r\n\r\n.barLegend {\r\n\tdisplay: flex;\r\n\tmargin-top: 2rem;\r\n\tgap: 5rem;\r\n}\r\n\r\n.barLegend > div {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n.barLegend > div p {\r\n  margin-top: -0.15rem;\r\n  margin-left: 0.7rem;\r\n}\r\n\r\n.barLegend > div:nth-child(1) span {\r\n  background-color: #c43908;\r\n}\r\n\r\n.barLegend > div:nth-child(2) span {\r\n  background-color: #ff8f3f;\r\n}\r\n\r\n.barLegend > div:nth-child(3) span {\r\n  background-color: #ffc44e;\r\n}\r\n\r\n.barLegend span {\r\n  display: inline-block;\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 25%;\r\n}\r\n\r\n.timeBlockCard {\r\n  height: 100%;\r\n}\r\n\r\n.timeCard {\r\n\twidth: 16.813rem;\r\n\theight: 28.875rem;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n\tborder-radius: 1rem;\r\n}\r\n\r\n.statsBlock {\r\n  margin-top: 3rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.costCard {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\twidth: 50%;\r\n\tpadding: 1.375rem 5em 0;\r\n\tbackground-color: #FFF;\r\n\theight: 111px;\r\n}\r\n\r\n.costCard span {\r\n\tfont-weight: 400;\r\n\tfont-size: 0.875rem;\r\n\tcolor: #767676;\r\n\tmargin-top: 0;\r\n}\r\n\r\n.costCard p {\r\n\tfont-weight: 900;\r\n\tfont-size: 1.875rem;\r\n\tcolor: #303030;\r\n\tmargin-top: 0.7rem;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.menuCard {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n\tborder-radius: 1rem;\r\n\tmargin-top: 1rem;\r\n\twidth: 100%;\r\n\tpadding: 0 5em 0;\r\n}\r\n\r\n.menuCard :global(.p-card-title) {\r\n\tcolor: #303030;\r\n\tfont-size: 20px;\r\n\tfont-weight: 700;\r\n\tmargin-top: 45px;\r\n}\r\n\r\n:global(.p-datatable-table) {\r\n\tborder-radius: 16px;\r\n\toverflow: hidden;\r\n}\r\n\r\n:global(.p-datatable-thead th:first-child > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-start;\r\n}\r\n\r\n:global(.p-datatable-thead th > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tcolor: #303030;\r\n\tfont-size: 1rem;\r\n\tfont-weight: 600;\r\n}\r\n\r\n:global(.p-datatable-thead th) {\r\n\tbackground-color: #C6D4E1;\r\n\tborder: 1px solid #FFF;\r\n\tpadding: 18px 30px;\r\n}\r\n\r\n:global(.p-datatable-tbody tr td) {\r\n\ttext-align: center;\r\n\tbackground-color: #FAF9F8;\r\n\tborder: 1px solid #FFF;\r\n\tfont-size: 1rem;\r\n\tfont-weight: 400;\r\n}\r\n\r\n/*.cellName {*/\r\n/*\twidth: 15.625rem;*/\r\n/*\tdisplay: flex;*/\r\n/*\tjustify-content: flex-start;*/\r\n/*\tmargin-left: 0.8rem;*/\r\n/*}*/\r\n\r\n.totalOrdersCardContent {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.doughnut {\r\n\twidth: 250px;\r\n\theight: 250px;\r\n\tmargin-top: 28px;\r\n}\r\n\r\n.customLegend {\r\n\tmargin-top: 38px;\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tjustify-content: center;\r\n\tgap: 1.5rem;\r\n\tmax-width: 100%;\r\n}\r\n\r\n.cost {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 1rem;\r\n}\r\n\r\n.costCardWrapper {\r\n\tdisplay: flex;\r\n\tgap: 1rem;\r\n\tflex-direction: row;\r\n}\r\n\r\n.table :global(.p-datatable-tbody td:nth-child(1)),\r\n.table :global(.p-datatable-thead th:nth-child(1)) {\r\n\twidth: 30%;\r\n\ttext-align: left;\r\n}\r\n\r\n.table :global(.p-datatable-tbody td:nth-child(2)),\r\n.table :global(.p-datatable-thead th:nth-child(2)) {\r\n\twidth: 20%;\r\n}\r\n\r\n.table :global(.p-datatable-tbody td:nth-child(3)),\r\n.table :global(.p-datatable-thead th:nth-child(3)) {\r\n\twidth: 10%;\r\n}\r\n\r\n.table :global(.p-datatable-tbody td:nth-child(4)),\r\n.table :global(.p-datatable-thead th:nth-child(4)) {\r\n\twidth: 15%;\r\n}\r\n\r\n.table :global(.p-datatable-tbody td:nth-child(5)),\r\n.table :global(.p-datatable-thead th:nth-child(5)) {\r\n\twidth: 20%;\r\n}\r\n\r\n@media screen and (min-width: 1105px) and (max-width: 1665px) {\r\n\t.cardWrapper {\r\n\t\tflex-wrap: wrap;\r\n\t\tjustify-content: center;\r\n\t}\r\n\t\r\n\t/* .chartsBlock {\r\n\t\toverflow-x: hidden;\r\n\t} */\r\n\t\r\n\t.barCard,\r\n\t.doughnutCard,\r\n\t.timeCard {\r\n\t\tflex: 1 1 300px;\r\n\t\tmax-width: 100%;\r\n\t}\r\n\t\r\n\t.barLegend {\r\n\t\tflex-wrap: wrap;\r\n\t\tjustify-content: center;\r\n\t\tgap: 1rem;\r\n\t}\r\n\t\r\n\t.menuCard {\r\n\t\tpadding: 0 2rem;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 1104px) {\r\n\t.cardWrapper {\r\n\t\tflex-direction: column;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t}\r\n\t\r\n\t.doughnutCard {\r\n\t\twidth: 24rem;\r\n\t\theight: auto;\r\n\t}\r\n\t\r\n\t.doughnutCard :global(.p-card-title) {\r\n\t\tcolor: #303030;\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 700;\r\n\t}\r\n\t\r\n\t.barCard {\r\n\t\twidth: 24rem;\r\n\t\theight: 400px;\r\n\t}\r\n\t\r\n\t.barCard :global(.p-card-title) {\r\n\t\tcolor: #303030;\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 700;\r\n\t}\r\n\t\r\n\t.barLegend {\r\n\t\tdisplay: flex;\r\n\t\tmargin-top: 26px;\r\n\t\tgap: 1rem;\r\n\t}\r\n\t\r\n\t.barLegend > div p {\r\n\t\tfont-size: 12px;\r\n\t\tfont-weight: 400;\r\n\t}\r\n\t\r\n\t.barLegend span {\r\n\t\tdisplay: inline-block;\r\n\t\twidth: 14px;\r\n\t\theight: 14px;\r\n\t\tborder-radius: 4px;\r\n\t}\r\n\t\r\n\t.timeCard {\r\n\t\twidth: 24rem;\r\n\t\theight: 451px;\r\n\t}\r\n\t\r\n\t.timeCard :global(.p-card-title) {\r\n\t\tcolor: #303030;\r\n\t\tfont-size: 16px;\r\n\t\tfont-weight: 700;\r\n\t}\r\n\t\r\n\t.menuCard {\r\n\t\tpadding: 0;\r\n\t\talign-self: center;\r\n\t}\r\n\t\r\n\t.menuCard :global(.p-card-title) {\r\n\t\tcolor: #303030;\r\n\t\tfont-size: 14px;\r\n\t\tfont-weight: 700;\r\n\t\tmargin-top: 0;\r\n\t}\r\n\t\r\n\t.menuCard :global(.p-card-content) {\r\n\t\tpadding-top: 0;\r\n\t}\r\n\t\r\n\t.menuCard :global(.p-card-content) h4{\r\n\t\tfont-size: 12px;\r\n\t\tfont-weight: 300;\r\n\t\tmargin-bottom: 8px !important;\r\n\t}\r\n\t\r\n\t.statsBlock {\r\n\t\tmargin-top: 36px;\r\n\t}\r\n\t\r\n\t.cost {\r\n\t\tflex-direction: column;\r\n\t}\r\n\t\r\n\t.costCardWrapper {\r\n\t\tflex-direction: column;\r\n\t}\r\n\t\r\n\t.costCard {\r\n\t\twidth: 100%;\r\n\t\tpadding: 0;\r\n\t\theight: 88px;\r\n\t\talign-items: center;\r\n\t}\r\n\t\r\n\t.costCard span {\r\n\t\tmargin-top: 18px;\r\n\t\tfont-size: 12px;\r\n\t\tfont-weight: 400;\r\n\t\tcolor: #767676;\r\n\t}\r\n\t\r\n\t.costCard p {\r\n\t\tfont-weight: 900;\r\n\t\tfont-size: 30px;\r\n\t\tmargin-top: 10px;\r\n\t}\r\n\t\r\n\t.table table thead tr th {\r\n\t\tmax-height: 31px !important;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-thead th) {\r\n\t\tpadding: 10px 0;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-thead th:first-child > div) {\r\n\t\tmargin-left: 30px;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n\t.table table thead tr th > div > span {\r\n\t\tfont-size: 10px;\r\n\t\tfont-weight: 700;\r\n\t}\r\n\t\r\n\t.table table tbody tr td > div {\r\n\t\tfont-size: 10px;\r\n\t\tfont-weight: 400;\r\n\t}\r\n\t\r\n\t.table table tbody tr td {\r\n\t\tfont-size: 10px;\r\n\t\tfont-weight: 400;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 425px) {\r\n\t.table table thead tr th > div > span {\r\n\t\tfont-size: 9px;\r\n\t\tfont-weight: 700;\r\n\t}\r\n\t\r\n\t.table table tbody tr td > div {\r\n\t\tfont-size: 9px;\r\n\t\tfont-weight: 400;\r\n\t}\r\n\t\r\n\t.table table tbody tr td {\r\n\t\tfont-size: 9px;\r\n\t\tfont-weight: 400;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 423px) and (min-width: 375px) {\r\n\t.doughnutCard {\r\n\t\twidth: 20rem;\r\n\t\theight: auto;\r\n\t}\r\n\t\r\n\t.customLegend {\r\n\t\tgap: 3rem;\r\n\t\tmargin-top: 1rem;\r\n\t}\r\n\t\r\n\t.barCard {\r\n\t\twidth: 20rem;\r\n\t\theight: 400px;\r\n\t}\r\n\t\r\n\t.timeCard {\r\n\t\twidth: 20rem;\r\n\t\theight: 451px;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 374px) {\r\n\t.doughnutCard {\r\n\t\twidth: 17rem;\r\n\t\theight: auto;\r\n\t}\r\n\t\r\n\t.customLegend {\r\n\t\tgap: 1.5rem;\r\n\t\tmargin-top: 0.9rem;\r\n\t}\r\n\t\r\n\t.barCard {\r\n\t\twidth: 17rem;\r\n\t\theight: 400px;\r\n\t}\r\n\t\r\n\t.barLegend span {\r\n\t\tmax-width: 10px;\r\n\t\tmax-height: 10px;\r\n\t\tborder-radius: 25%;\r\n\t}\r\n\t\r\n\t.timeCard {\r\n\t\twidth: 17rem;\r\n\t\theight: 451px;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 370px) {\r\n\t.table :global(.p-datatable-thead th),\r\n\t.table :global(.p-datatable-tbody td) {\r\n\t\tpadding: 6px 4px;\r\n\t\tfont-size: 8px;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-thead th:first-child > div) {\r\n\t\tmargin-left: 10px;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-thead th > div),\r\n\t.table :global(.p-datatable-tbody td > div) {\r\n\t\tfont-size: 8px;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-tbody td:nth-child(1)),\r\n\t.table :global(.p-datatable-thead th:nth-child(1)) {\r\n\t\twidth: 25%;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-tbody td:nth-child(2)),\r\n\t.table :global(.p-datatable-thead th:nth-child(2)) {\r\n\t\twidth: 18%;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-tbody td:nth-child(3)),\r\n\t.table :global(.p-datatable-thead th:nth-child(3)) {\r\n\t\twidth: 10%;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-tbody td:nth-child(4)),\r\n\t.table :global(.p-datatable-thead th:nth-child(4)) {\r\n\t\twidth: 15%;\r\n\t}\r\n\t\r\n\t.table :global(.p-datatable-tbody td:nth-child(5)),\r\n\t.table :global(.p-datatable-thead th:nth-child(5)) {\r\n\t\twidth: 18%;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export var chartsBlock = `AuRXwF9VsP8fQq1a`;
export var cardWrapper = `B5s355_gSI7ItcD6`;
export var label = `iqtx7ymJ3Roy3C5j`;
export var labelTitle = `QXRnIuUGzcm0uOKl`;
export var labelValue = `RuamqV3Xxkom2CqJ`;
export var labelDot = `Pyqd8S5JSC0zR2L_`;
export var timeBlocksWrapper = `MIMjymJE5pk3gs1I`;
export var timeBlock = `oLWzot0tC7gavhWw`;
export var doughnutCard = `HrZfZT3iYo2GrjpC`;
export var barCard = `RBKMBOXtnh4Q1ohj`;
export var barCardContent = `Oh5Ir_c3QJo6As9g`;
export var barChartWrapper = `VHDQ_rFZJ8sxjttS`;
export var barChartContent = `WbTw6OnjALtl5ak2`;
export var barChart = `ihcr_xpUf_MfYgMz`;
export var barLegend = `GWpnlugYRBAcZyTS`;
export var timeBlockCard = `dsVUQqiQMWNFDSOh`;
export var timeCard = `RpTxQH_UViY4ugEx`;
export var statsBlock = `dHKRy4_wQ9oMrEvZ`;
export var costCard = `jxJmKG5RNJQv3ZB_`;
export var menuCard = `iwcii3Z3vf4IhBvO`;
export var totalOrdersCardContent = `X9vFL3V15Is0vhYh`;
export var doughnut = `zQWnWoZsAsUTxM9P`;
export var customLegend = `SiMoS7Z0Ub4o3kkk`;
export var cost = `wy10DOQB8x4nfmQn`;
export var costCardWrapper = `ySXLOv_OJsbwRXOb`;
export var table = `q16ZVCV3sT0xAeLb`;
export default ___CSS_LOADER_EXPORT___;
